// External
import _ from "lodash";

// Internal
import { getGpaAssociatedDataRating } from "../ratingPrimitives";
import { getValueBasedOnReportType } from "../reportTypeHelpers";

export const getCreditCriteriaSet = ({
  ratings,
  termId,
  subjectId,
  criteriaSet,
  genericTagId,
  defineDifferentCredits = false,
  shouldAddAssociatedLevelCheck = false,
}) => {
  // Get computed rating
  const computedRating = getGpaAssociatedDataRating({
    ratings,
    subjectId,
    termId,
    genericTagId,
    defineDifferentCredits,
    shouldAddAssociatedLevelCheck,
  });

  // Currently overriding the grade point rating is not supported
  // const overRidingRating = getGpaAssociatedDataRating({
  //   computedRating: false,
  //   ratings,
  //   subjectId,
  //   termId,
  // });

  const rating = computedRating;

  const value = getValueBasedOnReportType()
    ? _.get(rating, "credit", "-")
    : _.get(rating, "value", "-");

  const updatedValue = _.isNumber(value) ? _.round(value, 2) : value;

  return {
    ...criteriaSet,
    value: updatedValue,
  };
};
